import React, { useState } from "react";
import "./Faq.scss"; // Make sure to import the CSS
import { useTranslation } from "react-i18next";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const { t } = useTranslation();

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqsRaw = t("faqSection.questions", { returnObjects: true });
  const faqs = Array.isArray(faqsRaw) ? faqsRaw : [];

  return (
    <div className="faq-container">
  <div className="faq-scroll-wrapper">
    <div className="faq-list">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
        >
          <div className="faq-question" onClick={() => handleToggle(index)}>
            <h3>{t(faq.question)}</h3>
            <div className="faq-toggle">
              <span>{activeIndex === index ? "-" : "+"}</span>
            </div>
          </div>
          {activeIndex === index && (
            <div className="faq-answer">
              <p>{t(faq.answer)}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</div>

  );
};

export default Faq;
